import React, { useState } from 'react';
import { Box, Button, ButtonGroup, Typography, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import SingleHistory from './SingleHistory';
import SingleHistoryEnhanced from './SingleHistoryEnhanced';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
    },
    toggleButton: {
        minWidth: 120,
    },
}));

/**
 * Composant wrapper qui permet de basculer entre l'ancienne et la nouvelle version
 * de l'historique des stocks
 * 
 * @param {Object} props
 * @param {string} props.stockID - ID du stock au format "shop_id|product_id"
 * @param {boolean} props.defaultEnhanced - Utiliser la vue améliorée par défaut (default: true)
 */
const SingleHistoryToggle = ({ stockID, defaultEnhanced = true }) => {
    const classes = useStyles();
    const [useEnhanced, setUseEnhanced] = useState(() => {
        // Récupérer la préférence depuis localStorage
        const savedPreference = localStorage.getItem('stock_history_view_preference');
        if (savedPreference !== null) {
            return savedPreference === 'enhanced';
        }
        return defaultEnhanced;
    });

    const handleToggle = (enhanced) => {
        setUseEnhanced(enhanced);
        // Sauvegarder la préférence
        localStorage.setItem('stock_history_view_preference', enhanced ? 'enhanced' : 'classic');
    };

    return (
        <Box className={classes.root}>
            <Paper className={classes.header} elevation={0}>
                <Typography variant="h6">
                    Historique des Mouvements
                </Typography>
                
                <ButtonGroup size="small" color="primary">
                    <Button
                        className={classes.toggleButton}
                        variant={!useEnhanced ? "contained" : "outlined"}
                        onClick={() => handleToggle(false)}
                        startIcon={<ViewListIcon />}
                    >
                        Vue Classique
                    </Button>
                    <Button
                        className={classes.toggleButton}
                        variant={useEnhanced ? "contained" : "outlined"}
                        onClick={() => handleToggle(true)}
                        startIcon={<ViewModuleIcon />}
                    >
                        Vue Améliorée
                    </Button>
                </ButtonGroup>
            </Paper>

            <Box>
                {useEnhanced ? (
                    <SingleHistoryEnhanced stockID={stockID} />
                ) : (
                    <SingleHistory stockID={stockID} />
                )}
            </Box>
        </Box>
    );
};

export default SingleHistoryToggle;

